import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { InvoiceDetailModel } from 'src/app/models/invoicing/invoice-detail.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { FilterGlobalResponseModel } from 'src/app/models/responses/filter-global-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChargeAccountDetailService {

  private readonly _httpClient = inject(HttpClient);

  createChargeAccountDetail(chargeAccountDetailContract: InvoiceDetailModel): Observable<InvoiceDetailModel> {
    return this._httpClient.post<InvoiceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountDetail.CreateChargeAccountDetail}`,
      chargeAccountDetailContract
    );
  }

  deleteSomeDetails(chargeAccountDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountDetail.DeleteSomeDetails}`,
      chargeAccountDetailIds
    );
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean, storeConsolidated: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString()).set('storeConsolidated', storeConsolidated);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountDetail.ExportDetailConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  exportChargeAccountDetails(invoiceId: number): Observable<Blob> {
    const params = new HttpParams().set('invoiceId', invoiceId);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountDetail.ExportChargeAccountDetailsAsync}`,
      null, { params, responseType: 'blob' }
    );
  }

  getAllChargeAccountDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, storeConsolidated: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('storeConsolidated', storeConsolidated);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountDetail.GetAllChargeAccountDetailsWithPagination}`,
      filters, { params: params }
    );
  }

  getChargeAccountDetailById(chargeAccountDetailId: number): Observable<InvoiceDetailModel> {
    return this._httpClient.get<InvoiceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountDetail.GetChargeAccountDetailById}/${chargeAccountDetailId}`);
  }

  getChargeAccountDetailByKeys(itemFilters: Array<ItemFilterModel>): Observable<InvoiceDetailModel> {
    return this._httpClient.post<InvoiceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountDetail.GetChargeAccountDetailByKeys}`,
      itemFilters
    );
  }

  getChargeAccountDetailByChargeAccountId(chargeAccountId: number): Observable<Array<InvoiceDetailModel>> {
    return this._httpClient.get<Array<InvoiceDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountDetail.GetChargeAccountDetailsByChargeAccountId}/${chargeAccountId}`);
  }

  getChargeAccountsDetailsByChargeAccountIdWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, invoiceId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('invoiceId', invoiceId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountDetail.GetChargeAccountsDetailsByChargeAccountsIdWithPagination}`,
      { params }
    );
  }

  getColumnsForDetailConsultation(): Observable<FilterGlobalResponseModel> {
    return this._httpClient.get<FilterGlobalResponseModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountDetail.GetColumnsForDetailConsultation}`);
  }

  getColumnsForDetailsChargeAccount(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountDetail.GetColumnsForDetailsChargeAccountAsync}`);
  }

  updateChargeAccountDetail(chargeAccountDetailContract: InvoiceDetailModel): Observable<InvoiceDetailModel> {
    return this._httpClient.put<InvoiceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.chargeAccountDetail.UpdateChargeAccountDetail}`,
      chargeAccountDetailContract
    );
  }
}
